export default __webpack_public_path__ + "static/media/recommendation-link.447186f5.svg";